import './main.scss'
import $ from 'jquery'

$(function () {
  const allBookmarks = $('.bookmarks')

  allBookmarks.each(function () {
    const bookmarks = $(this)
    const hiddenBookmarks = bookmarks.find('.bookmarks__content--more')
    const showMoreButton = bookmarks.find('.bookmarks__show-more-btn')
    const showLessButton = bookmarks.find('.bookmarks__show-less-btn')

    // hide bookmarks beyond the third
    hiddenBookmarks.hide()
    showLessButton.hide()

    showMoreButton.on('click', function () {
      $(this).hide()
      hiddenBookmarks.slideDown()
      showLessButton.show()
    })

    showLessButton.on('click', function () {
      $(this).hide()
      hiddenBookmarks.slideUp()
      showMoreButton.show()
    })
  })
})
